<template>
  <div class="section-test-drive">
    <div class="container car-view">
      <div class="main-description-wrap">
        <div class="main-description-promo"></div>
        <div style="width: 100%">
          <div class="line">
            <div class="w-12">
              <div class="container-title">Reynsluakstur</div>
            </div>
          </div>
          <div class="line">
            <div class="w-4 car-blog-image">
               <iframe v-if="videoUrl" ref="testDriveVideo" style="width:100%;min-height:182px;" :src="videoUrl"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
               <img v-else :src="imageUrl" />
            </div>
            <div class="w-8">
              <div class="car-blog-title">
                {{ title }}
              </div>
              <div class="car-blog-desc">
                {{ description }}
              </div>
              <div class="car-blog-actions">
                <button v-if="videoUrl" @click="showVideoPupup = true" class="bl-btn bl-primary-btn">
                  <VideoIcon/>
                  Horfa á reynsluakstur
                </button>
               <a class="bl-btn bl-simple-btn" :href="getBlogUrl">
                  <img src="/img/arrow.svg" /> Lesa meira</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showVideoPupup" class="test-drive-video">
      <div class="bg" @click="closeVideoPupup"></div>
      <div class="blog-video">
        <iframe v-if="videoUrl" :src="videoUrl"
                allowfullscreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen"
                msallowfullscreen="msallowfullscreen"
                oallowfullscreen="oallowfullscreen"
                webkitallowfullscreen="webkitallowfullscreen">
        </iframe>
        <img v-else :src="imageUrl" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import convertCategory from "@/helpers/convertCategory";
import VideoIcon from "../svg/Video";

export default {
  props: {
    post:{
      type:Object,
      default:() => {}
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    videoUrl: {
      type: String,
      default: "",
    },
    imageUrl: {
      type: String,
      default: "",
    },
    isPlayTestDrive: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VideoIcon
  },
  data() {
    return {
      showVideoPupup: false
    }
  },
  computed:{
    getBlogUrl(){
      const category = convertCategory(this.post.category_id);
      return `/allt-um-bila/${category.url}/${this.post.id}`
    }
  },
  methods:{
    playTestDrive() {

    },
    closeVideoPupup() {
      this.showVideoPupup = false
    }
  },
  watch: {
    isPlayTestDrive(newValue) {
      if(newValue){
        this.playTestDrive()
        this.$emit('testDrivePlayed')
      }
    }
  }
};
</script>

<style lang="less" scoped>
.desktop .section-test-drive {
  padding: 40px 0;
}
.section-test-drive .car-blog-actions {
  display: flex;
  align-items: center;
  button {
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    height: 30px;
    margin-right: 15px;

    svg {
      margin-right: 6px;
    }
  }
  a.bl-btn.bl-simple-btn {
    display: inline-flex;
    align-items: center;
    color: #22242a;
    img {
      margin-right: 8px;
    }
  }
}
</style>